import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/layout/page-header";
import {
  DashboardTabs,
  PageSnapshotCard,
  ParticipationCard,
  RosterHealthCard,
  SetupChecklistCard,
  ThisMonthCard,
} from "@/features/dashboard";
import { useMyOrg } from "@/features/orgs";

/**
 * The SMM's home (SB-41). It answers one question in the first three
 * seconds, "is this working?", and points at the screens that do the work
 * rather than trying to be them. Nothing here is a chart; charts live in
 * Analytics.
 */
export const Route = createFileRoute("/_authenticated/org/")({
  component: OrgOverview,
});

function OrgOverview() {
  const org = useMyOrg();
  return (
    <div>
      <PageHeader
        eyebrow={org.data?.name ?? "Your team"}
        title="Dashboard"
        description="Is this working? Where your team stands this month."
      />
      <DashboardTabs />
      <div className="space-y-6">
        <SetupChecklistCard />
        <div className="grid gap-4 md:grid-cols-2">
          <ThisMonthCard />
          <ParticipationCard />
          <RosterHealthCard />
          <PageSnapshotCard />
        </div>
      </div>
    </div>
  );
}
